import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export interface ToastBaseState {
    visible: boolean;
    title: string;
    message: string;
    data:any[];
    type: string;
    time: any
}

const initialState: ToastBaseState = {
    visible: false,
    title: '',
    message: '',
    data: [],
    type: '',
    time: Date.now(),
}

export const toastBaseSlice = createSlice({
    name: 'toastBase',
    initialState,
    reducers: {
        setVisibleToast: (state, action) => {
            state.visible = action.payload;
        },
        setDataToast: (state, action) => {
            const { message,data, title, type, time } = action.payload;
            state.message = message;
            state.data = data || []
            state.title = title;
            state.type = type;
            state.time = time;
        }
    },
});

export const selectVisibleToast = (state: RootState) => state.toastBase.visible;
export const selectTitleToast = (state: RootState) => state.toastBase.title;
export const selectMessageToast = (state: RootState) => state.toastBase.message;
export const selectDataToast = (state: RootState) => state.toastBase.data;
export const selectTypeToast = (state: RootState) => state.toastBase.type;

export const { setVisibleToast,setDataToast } = toastBaseSlice.actions;

export default toastBaseSlice.reducer;